import { render, staticRenderFns } from "./DefaultDeparturesComponent.vue?vue&type=template&id=0100d439&scoped=true"
import script from "./DefaultDeparturesComponent.vue?vue&type=script&lang=js"
export * from "./DefaultDeparturesComponent.vue?vue&type=script&lang=js"
import style0 from "./DefaultDeparturesComponent.vue?vue&type=style&index=0&id=0100d439&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0100d439",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0100d439')) {
      api.createRecord('0100d439', component.options)
    } else {
      api.reload('0100d439', component.options)
    }
    module.hot.accept("./DefaultDeparturesComponent.vue?vue&type=template&id=0100d439&scoped=true", function () {
      api.rerender('0100d439', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/warehouse/DefaultDeparturesComponent.vue"
export default component.exports